import React from 'react';

// styles
import {
  LabelContentWrapper,
  TextWrapper,
} from './LabelContentHorizontal-styles';
import {TextDefault} from '../../styles';
import {Skeleton} from '@mui/joy';

// types
type Props = {
  headerWidth: string;
  contentWidth: string;
  isFullWidth?: boolean;
};

const LabelContentHorizontalSkeleton = ({
  headerWidth,
  contentWidth,
  isFullWidth,
}: Props) => {
  return (
    <LabelContentWrapper>
      <TextWrapper isFullWidth={isFullWidth}>
        <TextDefault>
          <Skeleton variant="text" width={headerWidth} height={24} />
        </TextDefault>
      </TextWrapper>
      <TextWrapper isFullWidth={isFullWidth}>
        <Skeleton variant="text" width={contentWidth} height={24} />
      </TextWrapper>
    </LabelContentWrapper>
  );
};

export default LabelContentHorizontalSkeleton;
